<template>
    <div v-if="rating" class="flex space-x-1">
        <Star
            v-for="star in [1,2,3,4,5]"
            :class="[Math.round(rating) < star ? 'text-indigo-100' : 'text-indigo-500', starSize]"
        />
    </div>
</template>

<script>
import Star from "@/Components/Svg/Star.vue";

export default {
    components: {Star},
    props: {
        rating: {
            required: true
        },
        starSize: {
            default: 'w-4'
        }
    }
}
</script>
